<template>
  <div>
    <b-card no-body >
      <b-card-body>
        <b-row>
          <b-col
          sm="12"
          md="3"
          class="mt-2"
          >
            <b-form-group>
              <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="obtenerProgFertilizacion"
              :disabled="loading"
              v-b-tooltip.hover.top="'Recargar Datos'"
              >
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading" />
              </b-button>
              <b-button
              variant="gradient-primary"
              size="sm" class="mr-1"
              :disabled="downloadExcel"
              @click="descargarExcel()"
              v-b-tooltip.hover.top="'Descargar Excel'"
              >
                <font-awesome-icon v-if="downloadExcel" icon="fa-solid fa-arrows-rotate" spin />
                <font-awesome-icon v-else icon="fa-solid fa-download"/>
              </b-button>
              <b-button
              variant="gradient-primary"
              size="sm" class="mr-1"
              :disabled="downloadExcel"
              @click="descargarBD()"
              v-b-tooltip.hover.top="'Descargar BD'"
              >
                <font-awesome-icon v-if="downloadExcel" icon="fa-solid fa-arrows-rotate" spin />
                <font-awesome-icon v-else icon="fa-solid fa-database"/>
              </b-button>
            </b-form-group>
          </b-col>

          <b-col
          sm="12"
          md="1"
          class="mt-2"
          >
            <b-dropdown
              id="dropdown-right"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              right
              size="sm"
              text="Filtros"
              variant="primary"
              icon="fa-solid fa-arrows-rotate"
              style="width:100%; border-radius: 40px;"
            >
              <h4 class="ml-1 mt-1 text-center">Filtrar por:</h4>
              <div
                class="lista_opciones_filtro"
                style="width: 350px;
                padding-left:15px;
                padding-right:15px;
                padding-top:20px;
                margin-bottom:70px;"
              >
                <b-form-group
                  label="Etapa"
                  label-for="etapa"
                >
                  <v-select
                    id="etapa"
                    v-model="etapa"
                    :options="etapas"
                    @input="aplicarFiltros"
                    @click.stop
                    multiple
                    class="select-size-sm"
                    placeholder="Seleccionar etapa ..."
                    style="margin-bottom: 20px;"
                    />
                </b-form-group>
                <b-form-group
                  label="Semana"
                  label-for="semana"
                >
                  <v-select
                    id="semana"
                    v-model="semana"
                    :options="semanas"
                    @input="aplicarFiltros"
                    @click.stop
                    multiple
                    class="select-size-sm"
                    placeholder="Seleccionar semana..."
                    style="margin-bottom: 20px;"
                  />
                </b-form-group>
                <b-form-group
                  label="Empresa"
                  label-for="empresa"
                >
                  <v-select
                    id="empresa"
                    v-model="empresa"
                    :options="empresas"
                    @input="aplicarFiltros"
                    @click.stop
                    multiple
                    class="select-size-sm"
                    placeholder="Seleccionar empresa ..."
                  />
                </b-form-group>
                <b-form-group
                  label="Columnas"
                  label-for="columnas"
                >
                  <v-select
                    id="columnas"
                    v-model="columna"
                    :options="columnas"
                    @input="editarColumnas()"
                    multiple
                    class="select-size-sm"
                    placeholder="Seleccionar columna..."
                  />
                </b-form-group>
              </div>
            </b-dropdown>
          </b-col>

          <b-col
          sm="12"
          md="4"
          >
            <b-form-group
                label="Cultivo"
                label-for="cultivo"
            >
              <v-select
                id="cultivo"
                v-model="cultivo"
                :options="cultivos"
                @input="aplicarFiltros"
                multiple
                class="select-size-sm"
                placeholder="Seleccionar cultivo ..."
                />
            </b-form-group>
          </b-col>

          <b-col
          sm="12"
          md="2"
          >
            <b-form-group
                label="Version"
                label-for="version"
            >
              <v-select
                id="version"
                v-model="version"
                :options="versiones"
                @input="aplicarFiltros"
                class="select-size-sm"
                placeholder="Seleccionar version ..."
                />
            </b-form-group>
          </b-col>

          <b-col
          sm="12"
          md="2"
          class="mt-2"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group size="sm">
                <b-form-input v-model="localSearch" @input="aplicarBusqLocal(true)" type="search" placeholder="Buscar" no-clearable />
                <b-input-group-append>
                  <b-button :disabled="!localSearch" @click="aplicarBusqLocal(false)">
                    Borrar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card no-body @contextmenu="mostrarEditadorColumnas">
      <!-- <span>Reportes de Fertilización</span> -->
      <b-table
        hover
        responsive
        small
        class="position-relative cont_tabla"
        :items="itemsFiltro"
        :fields="fields"
        :busy="loading"
        show-empty
        empty-text="No se encontraron datos en esta tabla."
        emptyFilteredText="No se encontraron datos con los parámetros ingresados."
        >
        <!--
          sticky-header="58vh"
        -->
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

        <template #head(etapa)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
              :toggle-class="`${etapa_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
              :style="`${etapa_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>ETAPA</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Etapa" label-for="etapa_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="etapa_filtro" v-model="etapa_filtro" :options="etapas" multiple
                    placeholder="Seleccionar etapa ..." @input="filtradoPorColumna('etapa', etapa_filtro)"
                    class="select-size-sm" />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="etapa_filtro = []; filtradoPorColumna('etapa', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <!-- <template #head(fundo)>
          <div class="text-nowrap">
            <b-dropdown menu-class="" size="sm" variant="btn"
              :toggle-class="`${fundo_filtro.length > 0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
              :style="`${fundo_filtro.length > 0 ? 'text-decoration: underline #fba820e6;' : ''}`">
              <template #button-content>
                <b>FUNDO</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Fundo" label-for="fundo_filtro" @click.prevent class="py-0 my-0">
                  <v-select id="fundo_filtro" v-model="fundo_filtro" :options="fundoFiltro" multiple
                    placeholder="Seleccionar fundo ..." @input="realizarFiltro('fundo', fundo_filtro)"
                    class="select-size-sm" />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="fundo_filtro = []; realizarFiltro('fundo', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>-->
      </b-table>
    </b-card>
  </div>
</template>

<script>
  import axiosIns from '../../libs/axios'
  import vSelect from 'vue-select'
  import ToastificationContent from '@core/components/toastification/ToastificationContent'
  import Ripple from 'vue-ripple-directive'
  import { heightTransition } from '@core/mixins/ui/transition'
  import {
    BCard,
    BCardBody,
    BFormInput,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    BSpinner,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    VBTooltip,
    BTooltip,
    BDropdown,
    BDropdownForm,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
  } from 'bootstrap-vue'

  // Función para obtener el número de semana ISO (estándar internacional)
  Date.prototype.getWeekNumber = function () {
      const d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
      const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
      const weekNumber = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
      return weekNumber;
  };

  // Obtener la fecha actual
  const fechaActual = new Date();
  // Obtener el número de semana ISO actual
  const numeroSemanaActual = fechaActual.getWeekNumber();

  export default {
    components: {
      BCard,
      BCardBody,
      BCol,
      BFormInput,
      BFormGroup,
      BRow,
      BTable,
      vSelect,
      BSpinner,
      BButton,
      BInputGroup,
      BInputGroupAppend,
      VBTooltip,
      BTooltip,
      BDropdown,
      BDropdownForm,
      BDropdownItem,
      BDropdownHeader,
      BDropdownDivider,
    },
    directives: {
      'b-tooltip': VBTooltip,
      Ripple,
    },
    mixins: [heightTransition],
    data: () => ({
      id_user: JSON.parse(localStorage.getItem('userData')).id,
      loading: false,
      items_completo:[],
      items: [],
      itemsFiltro: [],
      valoresPorAgrupar: ['etapa','producto'],
      etapa_filtro: [],
      etapa: [],
      etapas : [],
      columna:[],
      // columnas:['CAMPO','TURNO','LOTE'],
      columnas:['LOTE','TURNO','CAMPO'],
      localSearch: null,
      downloadExcel:false,
      semana: [],
      semanas: [],
      empresa: ["AGROVISION PERÚ S.A.C"],
      empresas: [
        "AGROVISION PERÚ S.A.C",
        "ARENA VERDE",
      ],
      isDropdownOpen: false,
      // cultivo: ['PALTA'],
      cultivo: [],
      // cultivos: [
      //   'ARANDANO','ESPARRAGO','PALTA','UVA', 'LIMON'
      // ],
      cultivos: [],
      // cultivos: [
      //   {text:"ARANDANO",value:"ARA"},
      //   {text:"ESPARRAGO",value:"ESP"}
      // ],
      version: [],
      versiones:[],

      fields:[
        {
          key: 'empresa',
          label: 'empresa',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
        },
        {
          key: 'cod_homologado',
          label: 'cod_homologado',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
        },
        {
          key: 'fundo',
          label: 'fundo',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
        },
        {
          key: 'cultivo',
          label: 'cultivo',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
        },
        {
          key: 'etapa',
          label: 'etapa',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
        },
        {
          key: 'producto',
          label: 'producto',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
        },
        {
          key: 'total_lun',
          label: 'lun',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_mar',
          label: 'mar',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_mie',
          label: 'mie',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_jue',
          label: 'jue',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_vie',
          label: 'vie',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_sab',
          label: 'sab',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_dom',
          label: 'dom',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
        {
          key: 'total_producto',
          label: 'total_producto',
          class: 'text-nowrap text-center',
          sortable: true,
          tdClass: 'alinear-una-sola-linea',
          thClass: 'py-0 alinear-medio',
          formatter: (value, key, item) => {
            // Redondea el valor a tres decimales antes de mostrarlo
            return parseFloat(value).toFixed(3);
          },
        },
      ]
    }),
    computed: {},
    // mounted() {
    //   this.asignarSemanas()
    // },
    async mounted() {
      await this.obtenerProgFertilizacion();
    },
    methods: {
      asignarSemanas(){
        const yo = this
        const DIA_EN_MILISEGUNDOS = 1000 * 60 * 60 * 24, DIAS_QUE_TIENE_UNA_SEMANA = 7, JUEVES = 4;

        const hoy = new Date()

        const fecha = new Date(Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));

        let diaDeLaSemana = fecha.getUTCDay(); // Domingo es 0, sábado es 6
        if (diaDeLaSemana === 0) {
          diaDeLaSemana = 7;
        }

        fecha.setUTCDate(fecha.getUTCDate() - diaDeLaSemana + JUEVES);

        const inicioDelAnio = new Date(Date.UTC(fecha.getUTCFullYear(), 0, 1));

        const diferenciaDeFechasEnMilisegundos = fecha - inicioDelAnio;

        const semInt = Math.ceil(((diferenciaDeFechasEnMilisegundos / DIA_EN_MILISEGUNDOS) + 1) / DIAS_QUE_TIENE_UNA_SEMANA)
        yo.semana = semInt <= 9 ? "0" + semInt.toString() : semInt.toString()

        for (let i = 1; i <= semInt; i++) {
          let z = i <= 9 ? "0" + i.toString() : i.toString()
          yo.semanas.push(z)
        }

      },

      obtenerProgFertilizacion(){
        const yo = this
        yo.loading = true
        const config = {
          method: 'get',
          url: 'pagricolas/fertilizacion/reportes/',
        }

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200){
              yo.items_completo = response.data;
              yo.items = response.data;

              for(let r of response.data){
                if(!yo.cultivos.includes(r['cultivo'])){
                  yo.cultivos.push(r['cultivo'])
                }

                if(!yo.etapas.includes(r['etapa'])){
                  yo.etapas.push(r['etapa'])
                }

                if(!yo.semanas.includes(r['semana'])){
                  yo.semanas.push(r['semana'])
                }

                if(!yo.versiones.includes(r['version'])){
                  yo.versiones.push(r['version'])
                }

              }

              // Ordeno los arrays
              yo.semanas.sort((a, b) => b - a)
              yo.versiones.sort((a, b) => b - a)
              yo.cultivos.sort();
              yo.etapas.sort();

              // if(yo.versiones){
              //   yo.version = yo.versiones[0]
              // }

              if(yo.semanas){
                yo.semana = yo.semanas[0]
              }

              yo.aplicarFiltros()

              // yo.mostrarNotificacion('¡Bien hecho!', 'CheckIcon', "Datos cargados correctamente", 'success', 5000)
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.mostrarNotificacion('Error en la edición', 'BellIcon', 'Error: \n '+error.toString(), 'danger', 5000)
          })
          .finally(function (){
            yo.loading = false
          })
      },

      aplicarFiltros(){
        const yo = this
        yo.itemsFiltrados = []
        let datosFiltrados = []
        // 1.-Realizo los filtros por Semana, Empresa, Cultivo
        datosFiltrados = yo.items_completo.filter(item => {
          // Verificar si todos los valores de cultivo, semana y empresa coinciden
          const empresaCoincide = yo.empresa.includes(item.empresa);
          const semanaCoincide = yo.semana.includes(item.semana);

          const etapaCoincide = yo.etapa.length === 0 || yo.etapa.includes(item.etapa);
          const cultivoCoincide = yo.cultivo.length === 0 || yo.cultivo.includes(item.cultivo);
          const versionCoincide = yo.version.length === 0 || yo.version.includes(item.version);
          // Si todos los valores coinciden, mantener el elemento
          return cultivoCoincide && semanaCoincide && empresaCoincide && etapaCoincide && versionCoincide;
        }).map(item => {
          // Agregar el campo de suma de los días de la semana
          const sumaDiasSemana = ['lun', 'mar', 'mie', 'jue', 'vie', 'sab', 'dom'].reduce((total, dia) => {
              return total + parseFloat(item[dia] || 0);
          }, 0);
          // Crear un nuevo objeto con el campo de suma agregado
          return {
              ...item,
              total_producto: sumaDiasSemana
          };
        });

        // 2.-Ahora agrupo por etapa, producto y los parametros que seleccione en el select Columnas
        let agrupadoYSumado = [];
        datosFiltrados.forEach(item => {
          // Generar una clave de agrupación basada en los valores de los campos especificados
          const clave = yo.valoresPorAgrupar.map(valor => item[valor]).join('-');

          // Verifico si ya existe una entrada en el objeto agrupado para la clave actual
          if (!agrupadoYSumado[clave]) {
              // Si no existe, creo una nueva entrada y establezco los valores iniciales
              agrupadoYSumado[clave] = {
                  ...item,
                  total_lun: parseFloat(item.lun || 0),
                  total_mar: parseFloat(item.mar || 0),
                  total_mie: parseFloat(item.mie || 0),
                  total_jue: parseFloat(item.jue || 0),
                  total_vie: parseFloat(item.vie || 0),
                  total_sab: parseFloat(item.sab || 0),
                  total_dom: parseFloat(item.dom || 0),
                  total_producto: parseFloat(item.total_producto || 0)
              };
          } else {
              // Si la entrada ya existe, sumar los valores correspondientes
              agrupadoYSumado[clave].total_lun += parseFloat(item.lun || 0);
              agrupadoYSumado[clave].total_mar += parseFloat(item.mar || 0);
              agrupadoYSumado[clave].total_mie += parseFloat(item.mie || 0);
              agrupadoYSumado[clave].total_jue += parseFloat(item.jue || 0);
              agrupadoYSumado[clave].total_vie += parseFloat(item.vie || 0);
              agrupadoYSumado[clave].total_sab += parseFloat(item.sab || 0);
              agrupadoYSumado[clave].total_dom += parseFloat(item.dom || 0);
              agrupadoYSumado[clave].total_producto += parseFloat(item.total_producto || 0);
          }
        });

        const resultadoFinal = Object.values(agrupadoYSumado);
        yo.itemsFiltro = resultadoFinal
      },

      mostrarEditadorColumnas(event){
        event.preventDefault(); // Prevenir el menú contextual del navegador
        if (event.button === 2) { // 2 es el código para el botón derecho del mouse
          console.log("HOLA")
        }

      },

      editarColumnas(){
        const yo = this
        // Reinicio los valors por agrupar y los fields
        yo.valoresPorAgrupar = ['etapa','producto']
        let cols_a_eliminar = ['campo','turno','lote']
        for (var i = yo.fields.length - 1; i >= 0; i--) {
          if (cols_a_eliminar.includes(yo.fields[i].key)) {
              yo.fields.splice(i, 1);
          }
        }

        for(let c of yo.columna){
          yo.valoresPorAgrupar.push(c.toLowerCase())

          let nuevoObjeto = {
            key: c.toLowerCase(),
            label: c.toLowerCase(),
            class: 'text-nowrap text-center',
            sortable: true,
            tdClass: 'alinear-una-sola-linea',
            thClass: 'py-0 alinear-medio',
          }
          var existe = yo.fields.some(function(obj) {
            return obj.key === nuevoObjeto.key;
          });

          if (!existe) {
            yo.fields.splice(5, 0, nuevoObjeto);
          } else {
            console.log("Ya existe un objeto con el mismo key.");
          }
        }
        // Vuelvo a Filtrar por la nueva actualización de columnas
        this.aplicarFiltros()
      },

      aplicarBusqLocal(accion){
        const yo = this
        // console.log("Busqueda Local")
        // console.log(yo.localSearch)
        let busqueda = yo.localSearch

        if(accion == false){
          yo.localSearch = ''
          this.aplicarFiltros()
        }

        if(busqueda == '' || busqueda == null){
          yo.localSearch = ''
          this.aplicarFiltros()
        }else{
          let resultadoFiltro = []
          resultadoFiltro = yo.itemsFiltro.filter(item =>
            item.producto.includes(busqueda)
          );
          yo.itemsFiltro = resultadoFiltro
        }
      },

      descargarExcel(){
        const yo = this
        // console.log(yo.itemsFiltro)
        let datos=[]
        const data = JSON.stringify(
          {
            "datas": yo.itemsFiltro,
            "id_user": yo.id_user,
            "columnas": yo.columna,
          }
        )
        const config = {
          method: 'post',
          url: '/pagricolas/fertilizacion/reporte/exportar/columnas_seleccionadas/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle fertilizacion.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
              {
                position: 'top-center',
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
      },

      descargarBD(){
        const yo = this
        // console.log(yo.itemsFiltro)
        let datos=[]
        const data = JSON.stringify(
          {
            "datas": yo.itemsFiltro,
            "id_user": yo.id_user
          }
        )
        const config = {
          method: 'post',
          url: '/pagricolas/fertilizacion/reporte/exportar/all/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              const fileURL = window.URL.createObjectURL(new Blob([response.data]));
              const fileLink = document.createElement('a');
              fileLink.href = fileURL;
              fileLink.setAttribute('download', "Exportar detalle fertilizacion.xlsx");
              document.body.appendChild(fileLink);
              fileLink.click();

              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Archivo creado',
                  icon: 'CheckIcon',
                  text: 'El archivo se creó satisfactoriamente.',
                  variant: 'success',
                },
              },
              {
                position: 'top-center',
              })
            }
          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la creación del archivo',
                icon: 'XIcon',
                text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function () {
            yo.loadingSAD = false
            yo.loadingSSD = false
          });
      },

      filtradoPorColumna(){
        const yo = this
        // let spd = yo.itemsFiltro
        let spd = yo.itemsResumen

        let filt = []
        let c = 0

        for (const valor of yo.filtro) {
          if (valor.nombre === cabecera) {
            yo.filtro[c].valor = data
          }

          c += 1;
        }
        // console.log(yo.filtro)
        for (const values of yo.filtro) {
          for (const column of values.valor) {
            spd.forEach(function (value) {
              if (column === 'VACIOS') {
                if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  ') {
                  filt.push(value)
                }
              } else {
                // console.log(values.nombre)
                if (value[values.nombre] === column) {
                  filt.push(value)
                }
              }
            })
          }

          if (values.valor.length > 0) {
            if (values.valor[0] !== null) {
              spd = filt
              filt = []
            }
          }
        }

        yo.itemsFiltro = spd
      },

      mostrarNotificacion(titulo, icono, texto, variante, tiempo){
        this.$toast({
              component: ToastificationContent,
              props:{
                title: titulo,
                icon: icono,
                text: texto,
                variant: variante
              }
            },
            {
              timeout: tiempo,
              position: 'top-center',
            })
      },

      dropdownOpened() {
        this.isDropdownOpen = true;
      },
      dropdownClosed() {
        this.isDropdownOpen = false;
      }

    },
  }
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';

  .cont_tabla{
    min-height: 400px;
    max-height: 900;
  }

  .alinear-una-sola-linea {
    white-space: nowrap !important;
  }

  .alinear-medio {
    vertical-align: middle !important;
  }

  .select-dropdown {
    max-height: 30px; /* Ajusta la altura máxima según tus necesidades */
    overflow-y: scroll/* Permite el scroll vertical */
  }

</style>
